/**
 * 模組頁面代碼 : 1210-UI-01
 * 頁面說明 : 電梯資料清單列表頁面
 * @module modules/elevator/components/ElevatorgPage
 */

// ----- import from npm modules -----
import $ from 'jquery';

// ----- import from base libraries -----
import {
    React,
    PropTypes,
    BaseComponent,
    connect,
    AccessModeEnums,
    ModuleEnums,
} from '../../../components/BaseComponent';

import {
    DataTableComponent,
    batchCheckControls,
} from '../../../components/CommonComponent';

import { AlertModalModeEnums } from 'web/components/AlertModal';
import Breadcrumb from '../../../features/main-frame/components/Breadcrumb';

class ElevatorPage extends BaseComponent {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            searchBuildingId: '',
            searchElevatorName: '',
            searchElevatorId: 0,
            elevatorList: [],
        };
        this.setSearchBuildingId = this.setSearchBuildingId.bind(this);
        this.setSearchElevatorName = this.setSearchElevatorName.bind(this);
        this.setSearchElevatorId = this.setSearchElevatorId.bind(this);
        this.setElevatorList = this.setElevatorList.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.prepareElevatorTable = this.prepareElevatorTable.bind(this);
        this.addEventListeners = this.addEventListeners.bind(this);
        this.onBatchHandle = this.onBatchHandle.bind(this);
    }

    setSearchBuildingId(searchBuildingId) {
        this.setState({ searchBuildingId });
    }

    setSearchElevatorName(searchElevatorName) {
        this.setState({ searchElevatorName });
    }

    setSearchElevatorId(searchElevatorId) {
        this.setState({ searchElevatorId });
    }

    setElevatorList(elevatorList) {
        this.setState({ elevatorList: elevatorList });
    }

    // Handle change event
    handleChange = (event) => {
        const target = event.target;
        let value = target.value;

        // 當選擇大樓時，要更新電梯選項
        if (target.id === 'searchBuildingSelection') {
            const buildingId = parseInt(value);
            this.setSearchBuildingId(buildingId);
            const building = this.props.buildingSelection.find(building => building.buildingId === buildingId);
            const elevatorList = building !== null && building !== undefined ? building.elevators : [];
            this.setState({ elevatorList });

        }
    };

    prepareElevatorTable = () => {
        const { elevatorList } = this.props;

        // 定義資料內容
        const dataSet = elevatorList.map((elevator) => {
            return [
                elevator.buildingName,
                elevator.elevatorName,
                elevator.elevatorNum,
                elevator.updateTime,
                elevator.flgStatus,
            ];
        });

        // 定義欄位屬性
        const columnConfig = [
            {
                orderable: false,
                order: null,
                title: '<div class="form-check"><input class="form-check-input" type="checkbox" value="" id="check-all" data-show-indeterminate="true"/><label class="form-check-label" for="check-all"></label></div>',
                data: null,
                render: function (data, type, row, meta) {
                    let checkboxId = 'cks-elevator-' + meta.row;
                    return `<div class="form-check">
                                <input class="form-check-input item-cks-elevator" type="checkbox" value="" id="${checkboxId}" name="cks" />
                                <label class="form-check-label" for="${checkboxId}"></label>
                            </div>`;
                },
                width: '5%',
            },
            { title: '大樓名稱', className: 'dt-center', data: 0 },
            { title: '電梯名稱', className: 'dt-center', data: 1 },
            { title: '電梯編號', className: 'dt-center', data: 2 },
            { title: '修改時間', className: 'dt-head-center', data: 3, render: DataTable.render.datetime('YYYY-MM-DD HH:mm:ss'), type: 'datetime' },
            {
                orderable: false,
                order: null,
                title: '啟用',
                data: 4,
                className: 'dt-center',
                render: (data, type, row, meta) => {
                    let enableId = 'eab-elevator-' + meta.row;
                    let isChecked = data === 'A' ? 'checked' : '';
                    let enableButton = this.checkPermission(ModuleEnums.ELEVATOR, AccessModeEnums.DELETE) ? '' : 'disabled';
                    return `<div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch" id="${enableId}" ${isChecked} ${enableButton} />
                                <label class="form-check-label" for="${enableId}"></label>
                            </div>`;
                },
            },
            {
                orderable: false,
                order: null,
                data: null,
                className: 'dt-right',
                render: (data, type, row, meta) => {
                    let floorId = 'flr-setting-' + meta.row;
                    let editId = 'edit-elevator-' + meta.row;
                    let floorSettingButton = this.checkPermission(ModuleEnums.FLOOR, AccessModeEnums.READ) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${floorId}">
                            <svg class="btn__icon btn__icon--sm me-1" aria-hidden="true">
                                <use href="#ico-building"></use>
                            </svg>
                            樓層設定
                        </button>` : '';
                    let editButton = this.checkPermission(ModuleEnums.ELEVATOR, AccessModeEnums.UPDATE) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${editId}">
                            修改
                        </button>` : '';
                    return `<div class="btn-group" role="group" aria-label="">
                                ${floorSettingButton}
                                ${editButton}
                            </div>`;
                },
            },
        ];

        // 定義排序設定
        const orderConfig = {
            idx: 1,
            dir: 'asc',
        };

        // 定義固定欄位設定
        const fixedColumnsConfig = {
            start: 1,
        }

        // 先清除datatable
        if ($.fn.DataTable.isDataTable('#datatable__elevatorList')) {
            $('#datatable__elevatorList').DataTable().destroy();
        }

        // 重新繪製datatable
        DataTableComponent('#datatable__elevatorList', dataSet, columnConfig, orderConfig, fixedColumnsConfig, true, true);
        this.addEventListeners();
        batchCheckControls();
    }

    componentDidMount() {
        // 確認是否有帳號管理讀取權限
        this.checkPermission(ModuleEnums.ELEVATOR, AccessModeEnums.READ);
    }

    componentDidUpdate(prevProps) {
        const { needElevatorLoad, setNeedElevatorLoad, elevatorList } = this.props;
        if (needElevatorLoad && 
            needElevatorLoad !== prevProps.needElevatorLoad) {
            if (elevatorList.length > 0) {
                this.prepareElevatorTable();
            }
            setNeedElevatorLoad(false);
        }
    }

    handleSearch(e) {
        e.preventDefault();
        const searchForm = new FormData(e.target);
        const buildingId = parseInt(searchForm.get('searchBuildingSelection')? searchForm.get('searchBuildingSelection') : 0);
        const elevatorName = searchForm.get('searchElevatorName');
        const elevatorId = parseInt(searchForm.get('searchElevatorSelection')? searchForm.get('searchElevatorSelection') : 0);
        this.props.setSearchElevator(buildingId, elevatorName, elevatorId);
        this.props.fetchElevatorList(buildingId, elevatorName, elevatorId).then(() => {
            // Get data and redraw datatable
            this.prepareElevatorTable();
        });
    }

    addEventListeners() {
        if (this.tableRef.current) {
            this.tableRef.current.addEventListener('click', (event) => {
                const button = event.target.closest('.btn');
                if (button && button.id.startsWith('flr-setting-')) {
                    this.props.onFloorList(parseInt(button.id.split('-')[2]));
                }
                if (button && button.id.startsWith('edit-elevator-')) {
                    this.props.onEditElevator(parseInt(button.id.split('-')[2]));
                }
            });
            this.tableRef.current.addEventListener('change', (event) => {
                const checkbox = event.target.closest('input[type="checkbox"]');
                if (checkbox && checkbox.id.startsWith('eab-elevator-')) {
                    const index = parseInt(checkbox.id.split('-')[2]);
                    const mode = checkbox.checked ? AlertModalModeEnums.ENABLE : AlertModalModeEnums.DISABLE;
                    const updateElevator = this.props.elevatorList[index];
                    if (updateElevator) {
                        let message = '';
                        if (mode === AlertModalModeEnums.ENABLE) {
                            message = `啟用 [ ${updateElevator.elevatorName} ] 的資料`;
                        } else {
                            message = `停用 [ ${updateElevator.elevatorName} ] 的資料`;
                        }
                        this.props.onEditElevatorStatus(mode, message, updateElevator.elevatorId);
                    } else {
                        console.log('No elevator found at index:', index);
                    }
                }
            });
        }
    }

    onBatchHandle(alertMode = AlertModalModeEnums.ENABLE) {
        const elevatorIds = [];
        const checkboxes = document.querySelectorAll('.item-cks-elevator');
        checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                const elevatorId = this.props.elevatorList[parseInt(checkbox.id.split('-')[2])].elevatorId;
                elevatorIds.push(elevatorId);
            }
        });
        // 如果沒有選擇任何資料就不處理
        if (elevatorIds.length === 0) {
            return;
        }

        this.props.onBatchHandle(alertMode, elevatorIds);      
    }

    render() {
        const { buildingSelection, onNewElevator } = this.props;
        return (
            <section id="datatable-container">
                <Breadcrumb categoryName="梯控管理" pageName="電梯資料" />
                <h4>電梯資料</h4>
                <div className="datatable__search">
                    <form className="d-flex gap-2 align-items-end needs-validation" onSubmit={this.handleSearch}>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchBuilding" className="form-label">大樓名稱*</label>
                            <select
                                className="form-select form-select-sm"
                                id="searchBuildingSelection"
                                name="searchBuildingSelection"
                                value={this.state.searchBuildingId}
                                onChange={this.handleChange}
                                required>
                                <option disabled value="">請選擇</option>
                                <option value="0">全部</option>
                                {buildingSelection.map((building, index) => (
                                    <option key={index} value={building.buildingId}>{building.buildingName}</option>
                                ))}
                            </select>
                        </div>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchElevatorName" className="form-label">電梯名稱</label>
                            <input type="text" className="form-control form-control-sm" id="searchElevatorName" name="searchElevatorName" value={this.state.searchElevatorName} onChange={e => this.setSearchElevatorName(e.target.value)} />
                        </div>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchElevatorNum" className="form-label">電梯編號</label>
                            <select
                                className="form-select form-select-sm"
                                id="searchElevatorSelection"
                                name="searchElevatorSelection"
                                value={this.state.searchElevatorId}
                                onChange={e => this.setSearchElevatorId(e.target.value)}
                            >
                                <option disabled value="">請選擇</option>
                                <option value="0">全部</option>
                                {this.state.elevatorList && this.state.elevatorList.map((elevator, index) => (
                                    <option key={index} value={elevator.elevatorId}>{elevator.elevatorName}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <button className="btn btn-primary" type="submit" aria-label="搜尋">
                                <svg className="btn__icon" aria-hidden="true">
                                    <use href="#ico-search"></use>
                                </svg>
                            </button>
                        </div>
                    </form>
                </div>
                <div className="datatable__tool">
                    <div className="d-flex align-items-center gap-2">
                        <div className="datatable__tool__label">
                            多筆選擇
                            <div id="checked-count-display"></div>
                        </div>
                        <div className="btn-group btn-group-sm" role="group" aria-label="">
                            {this.checkPermission(ModuleEnums.ELEVATOR, AccessModeEnums.DELETE) && (
                                <button type="button" className="btn btn-outline-secondary btn-batch" aria-label="啟用" id="btnBatchEnable" onClick={() => this.onBatchHandle(AlertModalModeEnums.ENABLE)}>啟用</button>
                            )}
                            {this.checkPermission(ModuleEnums.ELEVATOR, AccessModeEnums.DELETE) && (
                                <button type="button" className="btn btn-outline-secondary btn-batch" aria-label="停用" id="btnBatchDisable" onClick={() => this.onBatchHandle(AlertModalModeEnums.DISABLE)}>停用</button>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        {this.checkPermission(ModuleEnums.ELEVATOR, AccessModeEnums.CREATE) && (
                        <button type="button" className="btn btn-sm btn-primary" aria-label="新增" id="modalElevatorBtnNew" onClick={onNewElevator}>
                            <svg className="btn__icon me-2" aria-hidden="true">
                                <use href="#ico-plus"></use>
                            </svg>
                            新增
                        </button>
                        )}
                    </div>
                </div>
                <div className="datatable__data" ref={this.tableRef}>
                    <table id="datatable__elevatorList" className="display table table-hover align-middle nowrap"></table>
                </div>
            </section>
        );
    }
}

ElevatorPage.propTypes = {
};

ElevatorPage.defaultProps = {
};

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ElevatorPage);